import { render, staticRenderFns } from "./TagForm.vue?vue&type=template&id=dd06e382&scoped=true"
import script from "./TagForm.vue?vue&type=script&lang=js"
export * from "./TagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd06e382",
  null
  
)

export default component.exports